
define('text!modules/targeting/contextual/templates/bin_footer.html',[],function () { return '<dl class="headers">\n    <dt class="header column segment">Contextual Cost</dt>\n    <dd class="header column cpm" data-bind="contextual-cpm-cost">--</dd>\n    <div class="icon-spinner-footer"/>\n</dl>';});

